export default __webpack_public_path__ + "static/media/chevron_right.19201565.svg";